/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Roadmap_DescInputs */

const en_mk_preview_roadmap_desc = /** @type {(inputs: Mk_Preview_Roadmap_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break your plan into features, tasks, and a sequence your team can review.`)
};

const id_mk_preview_roadmap_desc = /** @type {(inputs: Mk_Preview_Roadmap_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pecah rencana menjadi fitur, tugas, dan urutan pengerjaan yang bisa ditinjau bersama.`)
};

/**
* | output |
* | --- |
* | "Break your plan into features, tasks, and a sequence your team can review." |
*
* @param {Mk_Preview_Roadmap_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_roadmap_desc = /** @type {((inputs?: Mk_Preview_Roadmap_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Roadmap_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_roadmap_desc(inputs)
	return en_mk_preview_roadmap_desc(inputs)
});